import { module } from "angular";
import { forEach } from "lodash";
import { map } from "rxjs/operators";

import type { Observable } from "rxjs";

import type { IHttpService } from "App/Modules/Services";

import type { IResponse } from "App/Modules/Models";
import { IrMap } from "App/Modules/Models";
import type { ITimeZonesRepository } from "./ITimeZonesRepository";

export default class TimeZonesRepository implements ITimeZonesRepository {
    public static $inject: string[] = ["mmHttpService", "$translate"];

    constructor(
        private readonly httpService: IHttpService,
        private readonly $translate: angular.translate.ITranslateService,
    ) {}

    public enhanceTimeZones(timeZones: string[]): IrMap<string, string> {
        const timeZonesDictionary = new IrMap<string, string>();

        forEach(timeZones, (tz) => {
            // eslint-disable-next-line prefer-template
            const translatedTz = this.$translate.instant("Entities.TimeZone." + tz);
            timeZonesDictionary.push({ key: tz, value: translatedTz });
        });

        return timeZonesDictionary;
    }

    public getAllTimeZones(): Observable<IResponse<IrMap<string, string>>> {
        return this.httpService.get<string[]>("timeZones").pipe(
            map((response: IResponse<any>) => {
                const dictionary = this.enhanceTimeZones(response.data);
                response.data = dictionary;

                return response;
            }),
        );
    }
}

module("mmRepositories").service("mmTimeZonesRepository", TimeZonesRepository);
